module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-11-bb0f76f9.png";